import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-slate-900 text-slate-300 py-12 pb-24 md:pb-12">
      <div className="container-custom">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8 pb-8 border-b border-slate-800">
          <div className="text-center md:text-left mb-6 md:mb-0">
            <h3 className="text-2xl font-bold text-white mb-1">{t.footer.title}</h3>
            <p className="text-lg text-brand-light">{t.footer.price}</p>
          </div>
          
          <div className="text-center md:text-right">
            <p className="text-slate-400 mb-2">{t.footer.contact}</p>
            <a href="tel:+17865291915" className="text-xl font-semibold text-white hover:text-brand-light transition-colors flex items-center justify-center md:justify-end">
              <SafeIcon name="Phone" className="w-5 h-5 mr-2" />
              786-529-1915
            </a>
            <p className="text-sm text-slate-500 mt-1">{t.footer.callText}</p>
          </div>
        </div>

        <div className="text-center text-sm text-slate-500 flex flex-col items-center justify-center">
          <SafeIcon name="Home" className="w-6 h-6 mb-3 opacity-50" />
          <p className="max-w-xl">
            {t.footer.disclaimer}
          </p>
          <p className="mt-4">
            &copy; {new Date().getFullYear()} {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;